export default [
    {
        name: 'environmentMapTexture',
        type: 'cubeTexture',
        path:
        [
            'textures/environmentMap/px.jpg',
            'textures/environmentMap/nx.jpg',
            'textures/environmentMap/py.jpg',
            'textures/environmentMap/ny.jpg',
            'textures/environmentMap/pz.jpg',
            'textures/environmentMap/nz.jpg'
        ]
    },
    {
        name: 'kasekiWModel',
        type: 'gltfModel',
        path: 'models/Kaseki/world_kaseki.gltf'
    },
    {
        name: 'kasekiCModel',
        type: 'gltfModel',
        path: 'models/Kaseki/kaseki-kun_center.gltf'
    },
    {
        name: 'kasekiLModel',
        type: 'gltfModel',
        path: 'models/Kaseki/kaseki-kun_left.gltf'
    },
    {
        name: 'kasekiRModel',
        type: 'gltfModel',
        path: 'models/Kaseki/kaseki-kun_right.gltf'
    },
]